import React from "react";
import { Col, Row, Table} from 'reactstrap';	
import { observer, inject } from 'mobx-react';
import { rtdb } from '../components/firebase/firebase';

@inject('observableStore')
@observer

class Stats extends React.Component {
	
	state = {afhaalStats: {transacties: 0, tokens: 0, aantal: 0, omzet: 0, items: {}, btw: 0}}	
	
	componentDidMount = () => {
		if(this.props.observableStore.currEvent !== ''){			
			var statPromises = [];
			var startDate = new Date(new Date().getFullYear(), 0, 1);
			var endDate = new Date(new Date().getFullYear(), 11, 31);
			for(var dt=new Date(startDate); dt<=endDate; dt.setDate(dt.getDate()+1)){
				const formatedTime = new Date(dt).getFullYear() + '-' + ("0" + (new Date(dt).getMonth() + 1)).slice(-2) + '-' + ("0" + new Date(dt).getDate()).slice(-2);
				statPromises.push(rtdb.ref('/stats/' + this.props.observableStore.oid + '/' + this.props.observableStore.currEvent + '/' + formatedTime + '/afhaalpunten/' + this.props.observableStore.apid).once('value'));
			}
			Promise.all(statPromises).then((vals) => {this.setStats(vals)});		}
	}
	
	setStats(vals){	
		var afhaalStats = {...this.state.afhaalStats}
		vals.forEach(snapshot => {						
			if(snapshot.val()){
				Object.keys(snapshot.val().items).forEach(item => {
					if(afhaalStats.items && item in afhaalStats.items){
						afhaalStats.items[item].aantal = afhaalStats.items[item].aantal + snapshot.val().items[item].aantal;
						afhaalStats.items[item].tokens = afhaalStats.items[item].tokens + snapshot.val().items[item].tokens;
						afhaalStats.items[item].omzet = afhaalStats.items[item].omzet + snapshot.val().items[item].omzet;
						afhaalStats.items[item].btw = afhaalStats.items[item].btw + snapshot.val().items[item].omzet / (1 + snapshot.val().items[item].btw) * snapshot.val().items[item].btw;
					}
					else{
						afhaalStats.items[item] = {};
						afhaalStats.items[item].aantal = snapshot.val().items[item].aantal;
						afhaalStats.items[item].tokens = snapshot.val().items[item].tokens;
						afhaalStats.items[item].omzet = snapshot.val().items[item].omzet;
						afhaalStats.items[item].btw = snapshot.val().items[item].omzet / (1 + snapshot.val().items[item].btw) * snapshot.val().items[item].btw;

					}
					afhaalStats.transacties = afhaalStats.transacties + snapshot.val().transacties;
					afhaalStats.aantal = afhaalStats.aantal + snapshot.val().items[item].aantal;
					afhaalStats.tokens = afhaalStats.tokens + snapshot.val().items[item].tokens;	
					afhaalStats.omzet = afhaalStats.omzet + snapshot.val().items[item].omzet;	
					afhaalStats.btw = afhaalStats.btw + snapshot.val().items[item].omzet / (1 + snapshot.val().items[item].btw) * snapshot.val().items[item].btw;					
				});
			}			
		});	
		this.setState({afhaalStats: afhaalStats});	
	}	
	
	render() {
		return (
			<div style={{paddingLeft: 10, paddingRight: 10, paddingBottom: 100}}>
				<Row style={{marginTop: 20}}>
					<Col lg="12">
						<h2 className="font-light text-muted topTitle" style={{fontSize: 28, fontWeight: 900, color: '#212529'}}>Verkoop</h2>
					</Col>
				</Row>
				<Row style={{paddingTop: 25}}>	
					<Col lg={12}>
						<div className="graph-display" style={{paddingTop: 10}}>
							<div style={{display: 'flex', justifyContent: 'space-between', paddingTop: 10}}>
								<h2 className="font-light text-muted" style={{marginTop: 10, fontSize: 20, color: '#212529',}}>Producten</h2>
							</div>	
							{this.state.afhaalStats.items && Object.entries(this.state.afhaalStats.items).length > 0 ? 
								<Table className="v-middle" responsive style={{marginTop: 20}}>								
								<thead>
									<tr>
										<td className="stats-td" style={{width: '35%', fontSize: 15, fontWeight: 900, color: '#595959'}}>Omschrijving</td>
										<td className="stats-td" style={{fontSize: 15, fontWeight: 900, color: '#595959'}}>Stuks</td>
										<td className="stats-td" style={{fontSize: 15, fontWeight: 900, color: '#595959'}}>Munten</td>
										<td className="stats-td" style={{fontSize: 15, fontWeight: 900, color: '#595959'}}>BTW</td>
										<td className="stats-td" style={{fontSize: 15, fontWeight: 900, color: '#595959'}}>Omzet</td>
									</tr>
								</thead>
								<tbody>
									{Object.entries(this.state.afhaalStats.items).filter(item => item[1].aantal > 0).sort((a, b) => {return b[1].omzet - a[1].omzet}).map((item, index) => (											
										<tr style={{background: index%2 !== 0 ? null : 'rgba(0,0,0,0.03)'}}>
											<td className="stats-td"><h6 style={{fontSize: 13, fontWeight: 500}}>{item[0]}</h6></td>
											<td className="stats-td"><h6 style={{fontSize: 13, fontWeight: 500}}>{item[1].aantal}</h6></td>
											<td className="stats-td"><h6 style={{fontSize: 13, fontWeight: 500}}>{item[1].tokens}</h6></td>
											<td className="stats-td"><h6 style={{fontSize: 13, fontWeight: 500}}>€ {(item[1].btw.toLocaleString("nl-NL", {minimumFractionDigits: 2, maximumFractionDigits: 2}))}</h6></td>
											<td className="stats-td"><h6 style={{maxWidth: 200, background: '#43A047', fontWeight: 500, minWidth: 100, textAlign: 'center', borderRadius: 5, color: '#fff', padding: 6, paddingTop: 7}}>€ {(item[1].omzet.toLocaleString("nl-NL", {minimumFractionDigits: 2, maximumFractionDigits: 2}))}</h6></td>
										</tr>	
									))}
								</tbody>							
								</Table>
							:
								<div style={{top: 0, height: 330, display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', textAlign: 'center'}}>Er zijn nog geen items gescanned</div>
							}	
						</div>													  
					</Col>
				</Row>
				{this.state.afhaalStats.items && Object.entries(this.state.afhaalStats.items).length > 0 ?
				<Row style={{paddingTop: 25, paddingBottom: 200}}>	
					<Col lg={12}>
						<div className="graph-display" style={{paddingTop: 10}}>
							<div style={{display: 'flex', justifyContent: 'space-between', paddingTop: 10}}>
								<h2 className="font-light text-muted" style={{marginTop: 10, fontSize: 20, color: '#212529',}}>Totaal</h2>
							</div>	
							<Table className="v-middle" responsive style={{marginTop: 20}}>								
							<thead>
								<tr>
									<td className="stats-td" style={{width: '35%', fontSize: 15, fontWeight: 900, color: '#595959'}}>Bestellingen</td>
									<td className="stats-td" style={{fontSize: 15, fontWeight: 900, color: '#595959'}}>Items</td>
									<td className="stats-td" style={{fontSize: 15, fontWeight: 900, color: '#595959'}}>Munten</td>
									<td className="stats-td" style={{fontSize: 15, fontWeight: 900, color: '#595959'}}>BTW</td>
									<td className="stats-td" style={{fontSize: 15, fontWeight: 900, color: '#595959'}}>Omzet</td>
								</tr>
							</thead>
							<tbody>
								<tr style={{background: 'rgba(0,0,0,0.03)', marginTop: 30}}>
									<td className="stats-td"><h6 style={{fontSize: 13, fontWeight: 500}}>{this.state.afhaalStats.transacties}</h6></td>
									<td className="stats-td"><h6 style={{fontSize: 13, fontWeight: 500}}>{this.state.afhaalStats.aantal}</h6></td>
									<td className="stats-td"><h6 style={{fontSize: 13, fontWeight: 500}}>{this.state.afhaalStats.tokens}</h6></td>
									<td className="stats-td"><h6 style={{fontSize: 13, fontWeight: 500}}>€ {(this.state.afhaalStats.btw.toLocaleString("nl-NL", {minimumFractionDigits: 2, maximumFractionDigits: 2}))}</h6></td>
									<td className="stats-td"><h6 style={{maxWidth: 200, background: '#43A047', fontWeight: 500, minWidth: 100, textAlign: 'center', borderRadius: 5, color: '#fff', padding: 6, paddingTop: 7}}>€ {(this.state.afhaalStats.omzet.toLocaleString("nl-NL", {minimumFractionDigits: 2, maximumFractionDigits: 2}))}</h6></td>
								</tr>	
							</tbody>							
							</Table>	
						</div>													  
					</Col>
				</Row>
				:null}
			</div>
		);
	}	
}

export default Stats;